import { ComboboxOption } from '@headlessui/react'

import { CheckAltIcon } from '@/modules/shared/icons/CheckAltIcon'
import { classNames } from '@/modules/shared/utils/classNames'

interface ComboBoxOptionItemProps<DataType> {
  item: DataType
  testId: string | undefined
  keyExtractor: (item: DataType) => string | number
  getSelectedItem: (item: DataType) => string
  isClient?: boolean
  selectedItem: DataType | null
  customItemComponent?: (item: DataType) => React.ReactNode
  selectedItems?: DataType[]
}

export function ComboboxOptionItem<T>({
  item,
  testId,
  keyExtractor,
  getSelectedItem,
  isClient,
  selectedItem,
  customItemComponent,
  selectedItems,
}: ComboBoxOptionItemProps<T>) {
  const isItemSelected =
    selectedItems && selectedItems.length > 0
      ? selectedItems.some((selectedItem) => keyExtractor(selectedItem) === keyExtractor(item))
      : selectedItem
        ? keyExtractor(selectedItem) === keyExtractor(item)
        : false
  return (
    <ComboboxOption
      data-testid={`option${testId ? `-${testId}` : ''}-${keyExtractor(item)}`}
      value={item}
      className={({ focus }) =>
        classNames('relative cursor-default select-none py-2 pl-3 pr-9', {
          'bg-primary text-white': focus,
          'text-gray-900': !focus,
        })
      }
    >
      {({ focus, selected }) => (
        <>
          <span
            className={classNames('block truncate', {
              'font-semibold': isItemSelected || selected,
            })}
          >
            {customItemComponent ? customItemComponent(item) : getSelectedItem(item)}
          </span>

          {(isItemSelected || selected) && (
            <span
              className={classNames('absolute inset-y-0 right-0 flex items-center pr-4', {
                'text-white': focus,
                'text-primary': !focus,
              })}
            >
              {isClient ? <CheckAltIcon className="size-4" /> : <CheckAltIcon className="size-5" />}
            </span>
          )}
        </>
      )}
    </ComboboxOption>
  )
}
